import React from "react";
import * as BABYLON from "@babylonjs/core/Legacy/legacy";

export const SPOTLIGHT_HEIGHT = 20;

const createScene = function (
  engine: BABYLON.Engine,
  canvas: HTMLCanvasElement
) {
  const scene = new BABYLON.Scene(engine);

  const camera = new BABYLON.FreeCamera(
    "Camera",
    new BABYLON.Vector3(40, 30, 0),
    scene
  );
  camera.attachControl(canvas, true);
  camera.keysUpward.push(69); //increase elevation
  camera.keysDownward.push(81); //decrease elevation
  camera.keysUp.push(87); //forwards
  camera.keysDown.push(83); //backwards
  camera.keysLeft.push(65);
  camera.keysRight.push(68);
  camera.inputs.addMouseWheel();
  camera.inertia = 0.8;

  if (camera.inputs._mouseInput) {
    camera.inputs._mouseInput.buttons = [1, 2];
  }

  camera.setTarget(BABYLON.Vector3.Zero());
  var light = new BABYLON.HemisphericLight(
    "hemiLight",
    new BABYLON.Vector3(-1, 1, 0),
    scene
  );

  // Skybox
  var skybox = BABYLON.MeshBuilder.CreateBox("skyBox", { size: 1000.0 }, scene);
  var skyboxMaterial = new BABYLON.StandardMaterial("skyBox", scene);
  skyboxMaterial.backFaceCulling = false;
  skyboxMaterial.reflectionTexture = new BABYLON.CubeTexture(
    "textures/skybox/skybox",
    scene
  );
  skyboxMaterial.reflectionTexture.coordinatesMode =
    BABYLON.Texture.SKYBOX_MODE;
  skyboxMaterial.diffuseColor = new BABYLON.Color3(0, 0, 0);
  skyboxMaterial.specularColor = new BABYLON.Color3(0, 0, 0);
  skybox.material = skyboxMaterial;

  const angle = Math.atan(1 / SPOTLIGHT_HEIGHT);

  const spotLight = new BABYLON.SpotLight(
    "spotLight",
    new BABYLON.Vector3(0, SPOTLIGHT_HEIGHT, 0),
    new BABYLON.Vector3(0, -1, 0),
    angle * 2,
    2,
    scene
  );
  spotLight.diffuse = BABYLON.Color3.Green();

  spotLight.intensity = 1;

  return {
    scene,
    camera,
  };
};

async function createEngine(canvas: HTMLCanvasElement) {
  const webGPUSupported = await BABYLON.WebGPUEngine.IsSupportedAsync;
  console.log({ webGPUSupported });
  // if (webGPUSupported) {
  //   const engine = new BABYLON.WebGPUEngine(canvas);
  //   await engine.initAsync();
  //   return engine;
  // }
  return new BABYLON.Engine(canvas, true, {
    preserveDrawingBuffer: true,
    stencil: true,
  });
}

export const useGameEngine = (
  canvasRef: React.RefObject<HTMLCanvasElement>
) => {
  const [gameEngine, setGameEngine] = React.useState<BABYLON.Engine>();

  const [gameScene, setGameScene] = React.useState<BABYLON.Scene>();

  const [camera, setCamera] = React.useState<BABYLON.Camera>();

  React.useEffect(() => {
    if (canvasRef.current === null) {
      return;
    }

    const canvas = canvasRef.current;
    createEngine(canvas).then((engine) => {
      setGameEngine(engine);

      const { scene, camera } = createScene(engine, canvas);
      setGameScene(scene);
      setCamera(camera);

      const hdrTexture = BABYLON.CubeTexture.CreateFromPrefilteredData(
        "textures/environment.env",
        scene
      );
      scene.environmentTexture = hdrTexture;

      engine.runRenderLoop(function () {
        scene.render();
      });

      window.addEventListener("resize", function () {
        console.log("RESIZE");
        engine.resize();
      });
    });
  }, [canvasRef]);

  return { gameEngine, gameScene, camera };
};
